import { render, staticRenderFns } from "./DirectorSelectSeller.vue?vue&type=template&id=481c435e"
import script from "./DirectorSelectSeller.vue?vue&type=script&lang=js"
export * from "./DirectorSelectSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports